import React, { useEffect } from "react";
import { PlayerType, RegisterToLeague, SubscriptionType } from "../../store/registration/model";
import { AppState } from "../../store/reducer";
import { Dispatch } from "redux";
import { setRegistrationPlayerType, setSubscriptionType } from "../../store/registration/actions";
import { connect } from "react-redux";
import { Paper, makeStyles, Theme, createStyles, Typography, Grid, Card, CardContent, List, ListItem, ListItemIcon, ListItemText, Button, Divider, CircularProgress } from "@material-ui/core";

import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';
import { currentPlayer } from "../../store/players/selectors";
import { Player } from "../../store/players/models";
import { Data } from "../../framework/data";
import { Alert } from "@material-ui/lab";
import { LeagueHeader } from "../../store/leagues/models";

interface PlayerTypeProps {
    subscriptionType: SubscriptionType;
    playerType: PlayerType;
    leagues: Data<LeagueHeader[]>;
    setPlayerType: (x: PlayerType) => void;
    setSubscriptionType: (x: SubscriptionType) => void;
    selectedLeague: RegisterToLeague;
    onProceed: () => void;
    onMoveBack: () => void;
    currentPlayer: Data<Player>;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        selectPanel: {
            borderLeft: 0,
            borderRight: 0,
            margin: '0 -32px',
            padding: '16px 32px',
            backgroundColor: theme.palette.grey[100]
        },
        title: {
            fontSize: 14
        },
        listIcon: {
            minWidth: 32,
            height: 20
        },
        selectedPlayerType: {
            boxShadow: `0px 0px 5px 0px ${theme.palette.primary.main} inset`
        },
        selectablePlayerType: {
            cursor: "pointer"
        },
        disabledPlayerType: {
            opacity: 0.5
        }
    }),
);

const PlayerTypeComponent: React.FC<PlayerTypeProps> = ({ subscriptionType, playerType, selectedLeague, setPlayerType, onProceed, onMoveBack, currentPlayer, leagues, setSubscriptionType }) => {

    const classes = useStyles();
    const regularDisabled = !!selectedLeague.city;
    const trialDisabled = currentPlayer.type === "LOADED" && !!currentPlayer.value && currentPlayer.value.playerType === PlayerType.REGULAR;

    useEffect(() => {
        if (leagues.type === "LOADED") {
            const league = leagues.value.find(x => x.id === selectedLeague.league.id);
            if (league) {
                if (league.yearlySubscriptionEnabled) {
                    setSubscriptionType(SubscriptionType.YEARLY);
                }
            }
        }
    }, [leagues, selectedLeague, setSubscriptionType]);

    return <>
        {
            currentPlayer.type === "LOADED" && leagues.type === "LOADED" ? (
                <>
                    <Paper variant="outlined" className={classes.selectPanel} square>
                        <Typography variant="subtitle1" style={{ marginLeft: 8 }}>Rodzaj konta</Typography>

                        {
                            (regularDisabled && trialDisabled) ? (
                                <Alert severity="error">Niestety, nie jest możliwa rejestracja istniejącego (płatnego) zawodnika do ligi w mieście, które nie wspiera w pełni ligi. Prosimy o kontakt z <a href="mailto:support@smarttennis.pl">support@smarttennis.pl</a></Alert>
                            ) : (<></>)
                        }

                        <Grid container direction="row" spacing={2}
                            justify="center"
                            alignItems="stretch">
                            {
                                !!leagues.value.find(l => l.id === selectedLeague.league.id)?.yearlySubscriptionEnabled ? (
                                    <Grid item xs={12} md={6} lg={5} className={regularDisabled ? classes.disabledPlayerType : ""}>
                                        <Card variant="outlined" className={(playerType === PlayerType.REGULAR && subscriptionType === SubscriptionType.YEARLY) ? classes.selectedPlayerType : classes.selectablePlayerType} onClick={() => {
                                            if (!regularDisabled) {
                                                setPlayerType(PlayerType.REGULAR);
                                                setSubscriptionType(SubscriptionType.YEARLY);
                                            }
                                        }}>
                                            <CardContent>
                                                <Typography className={classes.title} color="textSecondary">
                                                    Konto
                                        </Typography>
                                                <Typography variant="h5" component="h2">
                                                    SMART-ROCZNY {
                                                        !regularDisabled ? (
                                                            <>
                                                                <span style={{ textDecoration: 'line-through' }}>600 zł</span>
                                                                <b> - {leagues.value.find(x => x.id === selectedLeague.league.id)?.yearlyPrice} zł</b>
                                                            </>
                                                        ) : (<></>)
                                                    }
                                                </Typography>
                                                <List dense={true}>
                                                    <ListItem disableGutters={true}>
                                                        <ListItemIcon className={classes.listIcon}>
                                                            <CheckCircleIcon style={{ height: 20 }} color="primary" />
                                                        </ListItemIcon>
                                                        <ListItemText >
                                                            <Typography variant="body2" color="textSecondary">
                                                                zapis na wszystkie sezony 2026 - 2026/1, 2026/2, 2026/3
                                                    </Typography>
                                                        </ListItemText>
                                                    </ListItem>
                                                    <ListItem disableGutters={true}>
                                                        <ListItemIcon className={classes.listIcon}>
                                                            <CheckCircleIcon style={{ height: 20 }} color="primary" />
                                                        </ListItemIcon>
                                                        <ListItemText >
                                                            <Typography variant="body2" color="textSecondary">
                                                                przez 3 sezony zbierasz punkty do finałów rocznych
                                                    </Typography>
                                                        </ListItemText>
                                                    </ListItem>
                                                    <ListItem disableGutters={true}>
                                                        <ListItemIcon className={classes.listIcon}>
                                                            <CheckCircleIcon style={{ height: 20 }} color="primary" />
                                                        </ListItemIcon>
                                                        <ListItemText >
                                                            <Typography variant="body2" color="textSecondary">
                                                                możliwość wygrania wyjazdu na obóz tenisowy w Chorwacji z wyżywieniem i pakietem treningów
                                                    </Typography>
                                                        </ListItemText>
                                                    </ListItem>
                                                    <ListItem disableGutters={true}>
                                                        <ListItemIcon className={classes.listIcon}>
                                                            <CheckCircleIcon style={{ height: 20 }} color="primary" />
                                                        </ListItemIcon>
                                                        <ListItemText >
                                                            <Typography variant="body2" color="textSecondary">
                                                                finały roczne z transmisją video i sędziowaniem
                                                    </Typography>
                                                        </ListItemText>
                                                    </ListItem>
                                                    <ListItem disableGutters={true}>
                                                        <ListItemIcon className={classes.listIcon}>
                                                            <CheckCircleIcon style={{ height: 20 }} color="primary" />
                                                        </ListItemIcon>
                                                        <ListItemText >
                                                            <Typography variant="body2" color="textSecondary">
                                                                rywalizacja z zawodnikami z innych miast
                                                    </Typography>
                                                        </ListItemText>
                                                    </ListItem>
                                                     <ListItem disableGutters={true}>
                                                        <ListItemIcon className={classes.listIcon}>
                                                            <CheckCircleIcon style={{ height: 20 }} color="primary" />
                                                        </ListItemIcon>
                                                        <ListItemText >
                                                            <Typography variant="body2" color="textSecondary">
                                                                nie musisz pamiętać o zapisach na kolejne sezony, aby walczyć o Finals 2026
                                                    </Typography>
                                                        </ListItemText>
                                                    </ListItem>
                                                </List>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                ) : (<></>)
                            }
                            <Grid item xs={12} md={6} lg={5} className={regularDisabled ? classes.disabledPlayerType : ""}>
                                <Card variant="outlined" className={(playerType === PlayerType.REGULAR && subscriptionType === SubscriptionType.MONTHLY) ? classes.selectedPlayerType : classes.selectablePlayerType} onClick={() => {
                                    if (!regularDisabled) {
                                        setPlayerType(PlayerType.REGULAR);
                                        setSubscriptionType(SubscriptionType.MONTHLY);
                                    }
                                }}>
                                    <CardContent>
                                        <Typography className={classes.title} color="textSecondary">
                                            Konto
                                        </Typography>
                                        <Typography variant="h5" component="h2">
                                            SMART {
                                                !regularDisabled ? (

                                                    <b> - {leagues.value.find(x => x.id === selectedLeague.league.id)?.basePrice} zł</b>

                                                ) : (<></>)
                                            }
                                        </Typography>
                                        <List dense={true}>
                                            <ListItem disableGutters={true}>
                                                <ListItemIcon className={classes.listIcon}>
                                                    <CheckCircleIcon style={{ height: 20 }} color="primary" />
                                                </ListItemIcon>
                                                <ListItemText >
                                                    <Typography variant="body2" color="textSecondary">
                                                        dostęp do bazy przeciwników na podobnym poziomie
                                                    </Typography>
                                                </ListItemText>
                                            </ListItem>
                                            <ListItem disableGutters={true}>
                                                <ListItemIcon className={classes.listIcon}>
                                                    <CheckCircleIcon style={{ height: 20 }} color="primary" />
                                                </ListItemIcon>
                                                <ListItemText >
                                                    <Typography variant="body2" color="textSecondary">
                                                        możliwość umawiania się na mecze przez system
                                                    </Typography>
                                                </ListItemText>
                                            </ListItem>
                                            <ListItem disableGutters={true}>
                                                <ListItemIcon className={classes.listIcon}>
                                                    <CheckCircleIcon style={{ height: 20 }} color="primary" />
                                                </ListItemIcon>
                                                <ListItemText >
                                                    <Typography variant="body2" color="textSecondary">
                                                        rywalizacja o turniej finałowy i nagrody rzeczowe
                                                    </Typography>
                                                </ListItemText>
                                            </ListItem>
                                            <ListItem disableGutters={true}>
                                                <ListItemIcon className={classes.listIcon}>
                                                    <CheckCircleIcon style={{ height: 20 }} color="primary" />
                                                </ListItemIcon>
                                                <ListItemText >
                                                    <Typography variant="body2" color="textSecondary">
                                                        zniżki na rezerwacje partnerskich kortów tenisowych
                                                    </Typography>
                                                </ListItemText>
                                            </ListItem>
                                            <ListItem disableGutters={true}>
                                                <ListItemIcon className={classes.listIcon}>
                                                    <CheckCircleIcon style={{ height: 20 }} color="primary" />
                                                </ListItemIcon>
                                                <ListItemText >
                                                    <Typography variant="body2" color="textSecondary">
                                                        Smart Punkty wymienne na piłki, vouchery, owijki itp.
                                                    </Typography>
                                                </ListItemText>
                                            </ListItem>
                                            <ListItem disableGutters={true}>
                                                <ListItemIcon className={classes.listIcon}>
                                                    <CheckCircleIcon style={{ height: 20 }} color="primary" />
                                                </ListItemIcon>
                                                <ListItemText >
                                                    <Typography variant="body2" color="textSecondary">
                                                        zbieranie punktów do SmartTennis Finals
                                                    </Typography>
                                                </ListItemText>
                                            </ListItem>
                                        </List>
                                    </CardContent>
                                </Card>
                            </Grid>
                            <Grid item xs={12} md={6} lg={5} className={trialDisabled ? classes.disabledPlayerType : ""}>
                                <Card variant="outlined" className={(playerType === PlayerType.TRIAL && subscriptionType === SubscriptionType.MONTHLY) ? classes.selectedPlayerType : classes.selectablePlayerType} onClick={() => {
                                    if (!trialDisabled) {
                                        setPlayerType(PlayerType.TRIAL);
                                        setSubscriptionType(SubscriptionType.MONTHLY);
                                    }
                                }}>
                                    <CardContent>
                                        <Typography className={classes.title} color="textSecondary">
                                            Konto
                                </Typography>
                                        <Typography variant="h5" component="h2">
                                            Próbne (max 3 mecze) <b>- 0 zł</b>
                                        </Typography>
                                        <Typography className={classes.title} color="textSecondary">(dostępne tylko dla nowych graczy)</Typography>
                                        <List dense={true}>
                                            <ListItem disableGutters={true}>
                                                <ListItemIcon className={classes.listIcon}>
                                                    <CheckCircleIcon style={{ height: 20 }} color="primary" />
                                                </ListItemIcon>
                                                <ListItemText >
                                                    <Typography variant="body2" color="textSecondary">
                                                        dostęp do bazy przeciwników na podobnym poziomie
                                                    </Typography>
                                                </ListItemText>
                                            </ListItem>
                                            <ListItem disableGutters={true}>
                                                <ListItemIcon className={classes.listIcon}>
                                                    <CheckCircleIcon style={{ height: 20 }} color="primary" />
                                                </ListItemIcon>
                                                <ListItemText >
                                                    <Typography variant="body2" color="textSecondary">
                                                        możliwość umawiania się na mecze przez system
                                                    </Typography>
                                                </ListItemText>
                                            </ListItem>
                                            <ListItem disableGutters={true}>
                                                <ListItemIcon className={classes.listIcon}>
                                                    <CheckCircleIcon style={{ height: 20 }} color="primary" />
                                                </ListItemIcon>
                                                <ListItemText >
                                                    <Typography variant="body2" color="textSecondary">
                                                        zniżki na rezerwacje partnerskich kortów tenisowych
                                                    </Typography>
                                                </ListItemText>
                                            </ListItem>
                                            <ListItem disableGutters={true}>
                                                <ListItemIcon className={classes.listIcon}>
                                                    <CancelIcon style={{ height: 20 }} color="error" />
                                                </ListItemIcon>
                                                <ListItemText >
                                                    <Typography variant="body2" color="textSecondary">
                                                        rywalizacja o turniej finałowy i nagrody rzeczowe
                                                    </Typography>
                                                </ListItemText>
                                            </ListItem>
                                            <ListItem disableGutters={true}>
                                                <ListItemIcon className={classes.listIcon}>
                                                    <CancelIcon style={{ height: 20 }} color="error" />
                                                </ListItemIcon>
                                                <ListItemText >
                                                    <Typography variant="body2" color="textSecondary">
                                                        Smart Punkty wymienne na piłki, vouchery, owijki itp.
                                                    </Typography>
                                                </ListItemText>
                                            </ListItem>
                                            <ListItem disableGutters={true}>
                                                <ListItemIcon className={classes.listIcon}>
                                                    <CancelIcon style={{ height: 20 }} color="error" />
                                                </ListItemIcon>
                                                <ListItemText >
                                                    <Typography variant="body2" color="textSecondary">
                                                        brak możliwości zbierania punktów do SmartTennis Finals
                                                    </Typography>
                                                </ListItemText>
                                            </ListItem>
                                        </List>
                                    </CardContent>
                                </Card>
                            </Grid>
                        </Grid>

                    </Paper>
                    <Divider style={{ marginTop: 24, marginBottom: 32 }}></Divider>
                    <Button color="primary" onClick={onMoveBack}>
                        Wstecz
                    </Button>
                    <Button color="primary" variant="contained" onClick={onProceed}>
                        Dalej
                    </Button>
                </>
            ) : (
                    <div
                        style={{
                            width: "64px",
                            height: "64px",
                            marginLeft: "auto",
                            marginRight: "auto",
                        }}
                    >
                        <CircularProgress />
                    </div>
                )
        }

    </>;
};

const mapStateToProps = (state: AppState) => ({
    playerType: state.registration.playerType,
    selectedLeague: state.registration.leagueSelection,
    currentPlayer: currentPlayer(state),
    leagues: state.leagues.items,
    subscriptionType: state.registration.subscriptionType
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    setPlayerType: (x: PlayerType) => dispatch(setRegistrationPlayerType(x)),
    setSubscriptionType: (x: SubscriptionType) => dispatch(setSubscriptionType(x))
});

export default connect(mapStateToProps, mapDispatchToProps)(PlayerTypeComponent);